import React from 'react'

import Footer from '../../../componenets/footer/Footer'
import AnnouncementsContainer from '../../../containers/admin/announcements/AnnouncementsContainer'

function TAAnnouncements() {
  return (
    <div>
        {/* <Header /> */}
        {/* <Navbar /> */}
        <AnnouncementsContainer />
        {/* <Footer /> */}
    </div>
  )
}

export default TAAnnouncements